import { NgModule } from "@angular/core"
import { RouterModule, Routes } from "@angular/router"

import { routes } from "./consts"
import { authGuard } from "./modules/auth/guards"
import { configGuard } from "./modules/config/guards"
import { ClientLayoutComponent } from "./shared/client"
import { LayoutComponent } from "./shared/layout/layout.component"
import { NotFoundComponent } from "./shared/not-found/not-found.component"

const ROUTES: typeof routes = routes

const route: Routes = [
  {
    path: "",
    redirectTo: ROUTES.QUIZ_EVENTS,
    pathMatch: "full"
  },
  {
    path: "login",
    loadChildren: () =>
      import("./modules/auth/auth.module").then((m) => m.AuthModule)
  },
  {
    path: "404",
    component: NotFoundComponent
  },
  {
    path: "client",
    component: ClientLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/client/client.module").then((m) => m.ClientModule)
      },
      // {
      //   path: "dashboard",
      //   loadChildren: () =>
      //     import("./modules/dashboard/dashboard.module").then(
      //       (m) => m.DashboardModule
      //     )
      // },
      {
        path: "auctions",
        loadChildren: () =>
          import("./modules/auto-auction/auto-auction.module").then(
            (m) => m.AutoAuctionModule
          )
      }
    ]
  },
  {
    path: "",
    canActivate: [authGuard, configGuard],
    component: LayoutComponent,
    children: [
      {
        path: "quiz",
        loadChildren: () =>
          import("./modules/quiz/quiz.module").then((m) => m.QuizModule)
      },
      {
        path: "leaderboard",
        loadChildren: () =>
          import("./modules/leaderboard/leaderboard.module").then(
            (m) => m.LeaderboardModule
          )
      },
      {
        path: "auctionv2",
        loadChildren: () =>
          import("./modules/auctionv2/auctionv2.module").then(
            (m) => m.Auctionv2Module
          )
      },
      {
        path: "auction",
        loadChildren: () =>
          import("./modules/auction/auction.module").then(
            (m) => m.AuctionModule
          )
      },
      {
        path: "notifications",
        loadChildren: () =>
          import("./modules/notification/notification.module").then(
            (m) => m.NotificationModule
          )
      },
      {
        path: "config",
        loadChildren: () =>
          import("./modules/config/config.module").then((m) => m.ConfigModule)
      }
    ]
  },
  {
    path: "**",
    redirectTo: "404"
  }
]

@NgModule({
  imports: [
    RouterModule.forRoot(route, {
      // enableTracing: true,
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
